<template>
  <div class="atosa-marketing">
    <!-- Header -->
    <div class="header">
      <h1 class="main-title">GÓI SẢN PHẨM ATOSA - TRỢ LÝ SHOPEE MARKETING</h1>

      <!-- Navigation Tabs -->
      <div class="nav-tabs">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          :class="['nav-tab', { active: activeTab === tab.id }]"
          @click="activeTab = tab.id"
        >
          {{ tab.name }}
        </button>
      </div>
    </div>

    <!-- Pricing Cards -->
    <div class="pricing-section">
      <div class="pricing-cards">
        <!-- ECO Package -->
        <div class="pricing-card">
          <div class="card-header">
            <span class="badge popular">ĐANG DÙNG</span>
            <h3 class="package-name">Atosa Agent - ECO</h3>
            <div class="price">
              <span class="amount">200,000</span>
              <span class="currency">đ</span>
            </div>
          </div>

          <div class="features">
            <div class="feature-row">
              <span>Shop kết nối</span>
              <span class="value">1 shop</span>
            </div>
            <div class="feature-row check">
              <span>Care Ads tự động</span>
              <i class="icon-check">✓</i>
            </div>
            <div class="feature-row check">
              <span>Quản lý từ khóa</span>
              <i class="icon-check">✓</i>
            </div>
            <div class="feature-row check">
              <span>Bảo hiểm rủi ro</span>
              <i class="icon-check">✓</i>
            </div>
            <div class="feature-row limited">
              <span>Tuần xuất hoạt động</span>
              <span class="limited-text">Ổn định</span>
            </div>
            <div class="feature-row commission">
              <span>Chi phí vận hành</span>
              <div class="commission-info">
                <span class="percentage">1% doanh thu</span>
                <span class="detail">chiến dịch / ngày</span>
              </div>
            </div>
          </div>

          <button class="buy-btn">Mua Gói</button>
        </div>

        <!-- ULTRA Package -->
        <div class="pricing-card premium">
          <div class="premium-badge">
            <span>PREMIUM</span>
          </div>
          <div class="card-header">
            <h3 class="package-name">Atosa Agent - ULTRA</h3>
            <div class="price">
              <span class="amount">500,000</span>
              <span class="currency">đ</span>
            </div>
          </div>

          <div class="features">
            <div class="feature-row">
              <span>Shop kết nối</span>
              <span class="value">1 shop</span>
            </div>
            <div class="feature-row check">
              <span>Care Ads tự động</span>
              <i class="icon-check">✓</i>
            </div>
            <div class="feature-row check">
              <span>Quản lý từ khóa</span>
              <i class="icon-check">✓</i>
            </div>
            <div class="feature-row check">
              <span>Bảo hiểm rủi ro</span>
              <i class="icon-check">✓</i>
            </div>
            <div class="feature-row unlimited">
              <span>Tuần xuất hoạt động</span>
              <span class="unlimited-text">Nhanh</span>
            </div>
            <div class="feature-row commission">
              <span>Chi phí vận hành</span>
              <div class="commission-info">
                <span class="percentage">1.5% doanh thu</span>
                <span class="detail">chiến dịch / ngày</span>
              </div>
            </div>
          </div>

          <button class="buy-btn premium-btn">Mua Gói</button>
        </div>
      </div>
    </div>

    <!-- Active Products Section -->
    <div class="active-products">
      <div class="section-header">
        <i class="icon-check-circle">✅</i>
        <h2>Gói sản phẩm đang dùng</h2>
      </div>

      <div class="products-grid">
        <div
          v-for="product in activeProducts"
          :key="product.id"
          class="product-card"
        >
          <div class="product-icon">
            <span class="icon">📊</span>
          </div>
          <div class="product-info">
            <h4 class="product-name">{{ product.name }}</h4>
            <p class="product-date">Bản quyền đến: {{ product.expireDate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AtosaMarketing',
  data() {
    return {
      activeTab: 'agent',
      tabs: [
        { id: 'ads', name: 'Gói Atosa Shopee Ads' },
        { id: 'agent', name: 'Gói Atosa Agent' },
        { id: 'advanced', name: 'Gói Atosa Nâng cao' },
        { id: 'research', name: 'Gói Nghiên Cứu Thị Trường' }
      ],
      activeProducts: [
        {
          id: 1,
          name: 'Shopee Marketing - Atosa VIP',
          expireDate: '27-08-2030 15:02'
        },
        {
          id: 2,
          name: 'Atame Ads StarterG',
          expireDate: '14-07-2029 14:34'
        },
        {
          id: 3,
          name: 'Atosa Agent - ECO',
          expireDate: '01-12-2026 17:01'
        },
        {
          id: 4,
          name: 'Shopee Analysis - Phân Tích Thị Trường',
          expireDate: '24-09-2026 16:38'
        },
        {
          id: 5,
          name: 'Shopee Analysis - Atosa Ads Spy',
          expireDate: '24-09-2026 16:38'
        },
        {
          id: 6,
          name: 'Atosa International - Silver Pack',
          expireDate: '29-08-2025 09:46'
        }
      ]
    }
  }
}
</script>

<style scoped>
.atosa-marketing {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  padding: 20px;
}

.header {
  text-align: center;
  margin-bottom: 40px;
}

.main-title {
  color: white;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 30px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.nav-tabs {
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.nav-tab {
  padding: 12px 24px;
  border: none;
  background: rgba(255,255,255,0.1);
  color: white;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  font-weight: 500;
}

.nav-tab:hover {
  background: rgba(255,255,255,0.2);
  transform: translateY(-2px);
}

.nav-tab.active {
  background: white;
  color: #667eea;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}

.pricing-section {
  margin-bottom: 50px;
}

.pricing-cards {
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}

.pricing-card {
  background: white;
  border-radius: 20px;
  padding: 30px;
  width: 350px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.pricing-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.15);
}

.pricing-card.premium {
  border: 3px solid #ff6b6b;
  box-shadow: 0 10px 30px rgba(255,107,107,0.2);
}

.premium-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  background: linear-gradient(45deg, #ff6b6b, #ff8e8e);
  color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  transform: rotate(15deg);
  box-shadow: 0 4px 10px rgba(255,107,107,0.3);
}

.badge {
  background: linear-gradient(45deg, #4CAF50, #45a049);
  color: white;
  padding: 6px 16px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 15px;
}

.package-name {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin: 15px 0;
}

.price {
  margin: 20px 0;
}

.amount {
  font-size: 36px;
  font-weight: 800;
  color: #ff6b6b;
}

.currency {
  font-size: 20px;
  color: #ff6b6b;
  font-weight: 600;
}

.features {
  margin: 25px 0;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.feature-row:last-child {
  border-bottom: none;
}

.value {
  font-weight: 600;
  color: #666;
}

.icon-check {
  color: #4CAF50;
  font-weight: bold;
  font-size: 16px;
}

.limited-text {
  color: #ff9800;
  font-weight: 600;
  font-size: 14px;
}

.unlimited-text {
  color: #4CAF50;
  font-weight: 600;
  font-size: 14px;
}

.commission-info {
  text-align: right;
}

.percentage {
  color: #ff6b6b;
  font-weight: 600;
  display: block;
}

.detail {
  color: #999;
  font-size: 12px;
}

.buy-btn {
  width: 100%;
  padding: 15px;
  background: linear-gradient(45deg, #667eea, #764ba2);
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 20px;
}

.buy-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102,126,234,0.3);
}

.premium-btn {
  background: linear-gradient(45deg, #ff6b6b, #ff8e8e);
}

.premium-btn:hover {
  box-shadow: 0 8px 20px rgba(255,107,107,0.3);
}

.active-products {
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 25px;
}

.section-header h2 {
  color: #333;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.product-card {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 15px;
  transition: all 0.3s ease;
}

.product-card:hover {
  background: #e9ecef;
  transform: translateX(5px);
}

.product-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(45deg, #667eea, #764ba2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 24px;
}

.product-name {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 5px 0;
}

.product-date {
  color: #666;
  font-size: 14px;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .pricing-cards {
    flex-direction: column;
    align-items: center;
  }

  .pricing-card {
    width: 100%;
    max-width: 400px;
  }

  .main-title {
    font-size: 24px;
  }

  .nav-tabs {
    flex-direction: column;
    gap: 10px;
  }

  .nav-tab {
    width: 100%;
    max-width: 300px;
  }

  .products-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/test/index.vue